import { useAuth } from "@/lib/auth";
import TopBar from "@/components/TopBar";
import BackButton from "@/components/BackButton";
import { StoryCard } from "@/components/StoryCard";
import { Navigate } from "react-router-dom";
import { Sparkles, Instagram } from "lucide-react";

export default function StoryCardPage() {
  const { user } = useAuth();
  if (!user) return null;
  if (!user.is_verified) return <Navigate to="/app/verification" replace />;

  return (
    <div data-testid="story-card-page" className="min-h-screen pb-24">
      <TopBar subtitle="Your card"/>
      <div className="max-w-2xl mx-auto px-4 pt-4 space-y-5">
        <BackButton fallback="/app/me" label="Back"/>
        <div className="rounded-2xl border border-[#DC2626]/30 bg-gradient-to-br from-[#DC2626]/10 to-[#180D0D] p-5">
          <p className="text-xs uppercase tracking-[0.2em] text-[#DC2626] mb-1 flex items-center gap-1">
            <Sparkles size={12}/> Your verified card
          </p>
          <h1 className="font-display text-2xl font-bold">Share your <span className="gold-text">gold checkmark.</span></h1>
          <p className="text-sm text-zinc-300 mt-2 leading-relaxed">Post this to your Instagram story or WhatsApp status. Every signup from your card counts as a referral.</p>
        </div>

        <StoryCard user={user}/>

        <div className="rounded-2xl border border-zinc-800 bg-[#180D0D] p-5 text-sm text-zinc-300 leading-relaxed">
          <p className="font-semibold text-white mb-2 flex items-center gap-2"><Instagram size={16} className="text-[#DC2626]"/> How to share on Instagram</p>
          <ol className="space-y-1 list-decimal ml-5 text-zinc-400">
            <li>Tap <strong className="text-white">Download</strong> above.</li>
            <li>Open Instagram and tap the <strong className="text-white">+</strong> to create a story.</li>
            <li>Pick the downloaded image from your gallery.</li>
            <li>Add a link sticker to <strong className="text-white">nextscene.in</strong> so followers can join.</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
